/**
 * @description 保單保障內容給付保額類型 (enum)
 */
export enum PolicyCoverageBnfAmtTypesEnum {
  /** 清單 */
  L = 'L',
  /** 公式 */
  F = 'F',
  /** 自負額 */
  D = 'D',
  /** 清單 + 公式 */
  LF = 'LF',
  /** 公式 + 清單 */
  FL = 'FL',
  /** 清單 + 自負額 */
  LD = 'LD',
  /** 公式 + 自負額 */
  FD = 'FD',
  /** 清單 + 公式 + 自負額 */
  LFD = 'LFD'
}
